import { TriggeredEmailTemplates } from "@/common/api.service"
import { FETCH_TRIGGERED_EMAIL_TEMPLATES, FETCH_INDIVIDUAL_TRIGGERED_MAIL_TEMPLATE, SEND_TRIGGERED_TEST_MAIL, ADD_TRIGGERED_MAIL_TEMPLATE, UPDATE_TRIGGERED_MAIL_TEMPLATE,RESET_STATE, DELETE_TRIGGERED_EMAIL_TEMPLATE } from "./actions.type"
import { SET_EMAIL_TEMPLATES, SET_TRIGGERED_EMAIL_TYPES, SET_MAIL_PLACEHOLDERS, SET_INDIVIDUAL_TEMPLATE, SET_ERROR_TEMPLATE,STATE_RESET } from "./mutations.type"

const initialState = () => {
    return {
        triggeredemailtemplates:[],
        triggeremailtypes:[],
        tmailplaceholders:[],
        tindividualtemplate: [],
        templateerrors: null,
    }
}

let state = initialState()

const getters = {
    triggeredemailtemplates(state){
        return state.triggeredemailtemplates
    },
    triggeremailtypes(state) {
        return state.triggeremailtypes
    },
    tmailplaceholders(state) {
        return state.tmailplaceholders
    },
    tindividualtemplate(state) {
        return state.tindividualtemplate
    }
}

const actions = {
    async [FETCH_TRIGGERED_EMAIL_TEMPLATES](context, slug) {
        const { data } = await TriggeredEmailTemplates.get(''+slug)
        context.commit(SET_EMAIL_TEMPLATES, data.data)
        return data;
    },
    async [FETCH_INDIVIDUAL_TRIGGERED_MAIL_TEMPLATE](context, slug) {
        const { data } = await TriggeredEmailTemplates.get(slug)
        context.commit(SET_INDIVIDUAL_TEMPLATE, data.data)
        return data;
    },  
    async [SEND_TRIGGERED_TEST_MAIL](context, payload) {
        return await TriggeredEmailTemplates.test(payload, '')
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR_TEMPLATE, error.response.data.errors)
        });
    },  
    async [ADD_TRIGGERED_MAIL_TEMPLATE](context, payload) {
        return await TriggeredEmailTemplates.create(payload, '')
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR_TEMPLATE, error.response.data.errors)
        });
    },     
    async [UPDATE_TRIGGERED_MAIL_TEMPLATE](context, payload) {
        return await TriggeredEmailTemplates.update(payload, payload.id)
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR_TEMPLATE, error.response.data.errors)
        });
    },  
    async [DELETE_TRIGGERED_EMAIL_TEMPLATE] (context, id) {
        return await TriggeredEmailTemplates.delete(id)
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR_TEMPLATE, error.response.data.errors)
        });
    },    
    [RESET_STATE]({ commit }) {
        commit(STATE_RESET);
    }
}

const mutations = {
    [SET_EMAIL_TEMPLATES](state, templates) {
        state.triggeredemailtemplates = templates
    }, 
    [SET_TRIGGERED_EMAIL_TYPES](state, triggeremailtypes) {
        state.triggeremailtypes = triggeremailtypes
        state.triggeremailtypes.push("inbox_document")
    }, 
    [SET_MAIL_PLACEHOLDERS](state, placeholders) {
        let constructedPlaceholders = []
        placeholders.forEach(element => 
            constructedPlaceholders.push('{{'+element+'}}')
        );
        state.tmailplaceholders = constructedPlaceholders;
    },
    
    [SET_ERROR_TEMPLATE](state, error) {
        state.templateerrors = error
    },      
    [SET_INDIVIDUAL_TEMPLATE](state, tindividualtemplate) {
        state.tindividualtemplate = tindividualtemplate
    },    
    [STATE_RESET](state) {
        Object.assign(state, initialState())
    } 
};

export default {
    state,
    getters,
    actions,
    mutations
};